export const DevelopmentPermissions = {
  "General Manager": [],
  "Asst. General Manager": [],
  Manager: [
    {
      path: "/development/designs",
      label: "Designs",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summery",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Designer: [
    {
      path: "/development/designs",
      label: "Designs",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Assistant Manager": [],
  Incharge: [],

  Executive: [],
  "Jr. Executive": [],
  "Sr. Executive": [],
};
